import React from 'react';

const ErrorPage = () => (
  <div className="business-banner fullheight-banner">
    <div className="hvrbox">
      <img src="/images/_bg/404.jpg" alt="404" className="hvrbox-layer_bottom" />
      <div className="hvrbox-layer_top">
        <div className="container">
          <div className="overlay-text text-center error-404-body">
            <span> 404 </span>
            <h4>Page not found!</h4>
            <p>We’re sorry, the page you have looked for does not exist in our database! Maybe go to our</p>
            <a href="home-one.html" className="btn bussiness-btn-larg">
              Home
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default ErrorPage;



// WEBPACK FOOTER //
// ./src/components/404.js